module.exports = __webpack_public_path__ + "img/walk.0e92ec1b.svg";